module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a6kqe"))).then(() => parcelRequire('3a9aZ'));